import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { TenantOnboardingService } from '../services/tenant-onboarding.service';

function getSlugFromRouteOrUrl(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string {
  const fromParams =
    route.paramMap.get('slug') ?? route.parent?.paramMap?.get('slug') ?? '';
  if (fromParams) return fromParams;
  const match = state.url.match(/^\/t\/([^/]+)/);
  return match ? match[1] : '';
}

export const tenantOnboardingGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const router = inject(Router);
  const onboardingService = inject(TenantOnboardingService);
  const authService = inject(AuthService);
  const slug = getSlugFromRouteOrUrl(route, state);
  const bypassOnboardingGate =
    state.url.includes('/payment/complete') || state.url.includes('/billing');

  if (bypassOnboardingGate) {
    return of(true);
  }

  return onboardingService.getStatus(true).pipe(
    map((status) => {
      if (status.onboardingDone) {
        if (state.url.includes('/onboarding') && slug) {
          return router.createUrlTree(['/t', slug, 'dashboard']);
        }
        return true;
      }
      if (state.url.includes('/onboarding')) {
        return true;
      }
      if (slug) {
        const q = router.parseUrl(state.url).queryParams;
        return router.createUrlTree(['/t', slug, 'onboarding'], {
          queryParams: Object.keys(q).length ? q : undefined,
        });
      }
      return false;
    }),
    catchError((err) => {
      if (err instanceof HttpErrorResponse && err.status === 404) {
        onboardingService.clearCache();
        authService.clearSession();
        return of(router.createUrlTree(['/login']));
      }
      if (slug) {
        const q = router.parseUrl(state.url).queryParams;
        return of(
          router.createUrlTree(['/t', slug, 'onboarding'], {
            queryParams: Object.keys(q).length ? q : undefined,
          }),
        );
      }
      return of(false);
    }),
  );
};
